import React from "react";
import "../../../App.css";
import SideBar from "components/layout/sidebar/Sidebar";
import DashboardNavBar from "components/layout/DashboardNavBar";
import Item from "./ItemCategory";

const AllItemCategory = ({ match }) => {
  return (
    <div>
      <DashboardNavBar />
      <SideBar />
      <Item />
    </div>
  );
}
export default AllItemCategory;